// 新的组织管理
export default [
  // 组织
  {
    path: '/organization/orgs',
    name: 'organization-orgs',
    component: () => import(/* webpackChunkName: "org" */ '@/views/organization/orgs/Index.vue'),
    meta: { title: '会员/企业管理' },
  },
  {
    path: '/organization/orgs/add',
    name: 'organization-orgs-add',
    component: () => import(/* webpackChunkName: "org" */ '@/views/organization/orgs/Index.vue'),
    meta: { title: '会员/企业管理' },
  },
  {
    path: '/organization/orgs/edit/:id',
    name: 'organization-orgs-edit',
    component: () => import(/* webpackChunkName: "org" */ '@/views/organization/orgs/edit/Edit.vue'),
    meta: { title: '会员/企业管理' },
  },
  {
    path: '/organization/orgs/detail/:id',
    name: 'organization-orgs-detail',
    component: () => import(/* webpackChunkName: "org" */ '@/views/organization/orgs/detail/Detail.vue'),
    meta: { title: '会员/企业管理' },
  },
  {
    path: '/organization/orgs/auth/:id',
    name: 'organization-orgs-auth',
    component: () => import(/* webpackChunkName: "org" */ '@/views/organization/orgs/Index.vue'),
    meta: { title: '会员/企业管理' },
  },
  {
    path: '/organization/orgs/upgrade/:id',
    name: 'organization-orgs-upgrade',
    component: () => import(/* webpackChunkName: "org" */ '@/views/organization/orgs/Index.vue'),
    meta: { title: '会员/企业管理' },
  },
  {
    path: '/organization/orgs/contact/:id',
    name: 'organization-orgs-contact',
    component: () => import(/* webpackChunkName: "org" */ '@/views/organization/orgs/Index.vue'),
    meta: { title: '会员/企业管理' },
  },

  // 子组织
  {
    path: '/organization/orgs/sub/:id',
    name: 'organization-orgs-sub',
    component: () => import(/* webpackChunkName: "org" */ '@/views/organization/orgs/sub-org/Index.vue'),
    meta: { title: '会员/企业管理' },
  },

  // 用户
  {
    path: '/organization/user',
    name: 'organization-users',
    component: () => import(/* webpackChunkName: "org" */ '@/views/organization/user/Index.vue'),
    meta: { title: '用户管理' },
  },
  {
    path: '/organization/user/add',
    name: 'organization-users-add',
    component: () => import(/* webpackChunkName: "org" */ '@/views/organization/user/add/Add.vue'),
    meta: { title: '用户管理' },
  },

  // 角色
  {
    path: '/organization/role',
    name: 'organization-roles',
    component: () => import(/* webpackChunkName: "org" */ '@/views/organization/role/Index.vue'),
    meta: { title: '角色管理' },
  },
  {
    path: '/organization/role/add',
    name: 'organization-roles-add',
    component: () => import(/* webpackChunkName: "org" */ '@/views/organization/role/add/Add.vue'),
    meta: { title: '角色管理' },
  },
];
